module.exports = __webpack_public_path__ + "static/media/careteam.e6715fc6.png";